"use client"

import { useState, useEffect, useCallback } from "react"
import { CHOOSE_SYNC_CONSTANTS } from "../constants/choose-sync"

export const useSyncSelection = () => {
  const [selectedOption, setSelectedOption] = useState<string | null>(null)

  // Load saved selection on mount
  useEffect(() => {
    const savedOption = localStorage.getItem(CHOOSE_SYNC_CONSTANTS.STORAGE_KEYS.SELECTED_SYNC_OPTION)
    if (savedOption) {
      setSelectedOption(savedOption)
    }
  }, [])

  const selectOption = useCallback((optionId: string) => {
    setSelectedOption(optionId)
    try {
      localStorage.setItem(CHOOSE_SYNC_CONSTANTS.STORAGE_KEYS.SELECTED_SYNC_OPTION, optionId)
    } catch (error) {
      console.error("Error saving selected sync option:", error)
    }
  }, [])

  const proceedToNext = useCallback((): boolean => {
    if (!selectedOption) {
      return false
    }

    try {
      localStorage.setItem(CHOOSE_SYNC_CONSTANTS.STORAGE_KEYS.CONNECTOR_FLOW_STEP, "3")
      return true
    } catch (error) {
      console.error("Error saving connector flow step:", error)
      return false
    }
  }, [selectedOption])

  return {
    selectedOption,
    selectOption,
    proceedToNext,
  }
}
